import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CommonService {

  appPages: any[] = [];

  constructor() { }

  setAppPages(membership, institution, institutionAdmin) {
    this.appPages = [];
    this.appPages.push({ title: 'Dashboard', url: '/home', icon: 'home' });
    if (membership?.subscription.hasDocuments) {
      this.appPages.push({ title: 'Dokumente', url: '/documents/folders', icon: 'documents' });
    }
    if (membership?.subscription.hasTimeline) {
      this.appPages.push({ title: 'Timeline', url: '/timeline', icon: 'time' });
    }
    if (membership?.subscription && institutionAdmin) {
      this.appPages.push({ title: 'Mitarbeiter', url: '/admin/employees', icon: 'people-circle' });
    }
    if (membership?.subscription.maxPatients > 0) {
      this.appPages.push({ title: 'Partienten', url: '/admin/patients', icon: 'bandage' });
    }
  }

}
